import React from "react";
import { Minus, Plus } from "lucide-react";

const btnCls = "w-8 h-8 rounded-full border border-black/15 flex items-center justify-center text-ink transition-colors hover:border-ink disabled:opacity-30 disabled:hover:border-black/15";

const Row = ({ label, sub, value, onDec, onInc, decDisabled, incDisabled, tid }) => (
  <div className="flex items-center justify-between py-3.5">
    <div>
      <p className="text-sm font-semibold text-ink">{label}</p>
      {sub && <p className="text-xs text-ink-faint mt-0.5">{sub}</p>}
    </div>
    <div className="flex items-center gap-3">
      <button type="button" onClick={onDec} disabled={decDisabled} data-testid={`${tid}-dec`} aria-label={`Decrease ${label}`} className={btnCls}>
        <Minus className="w-4 h-4" />
      </button>
      <span className="w-6 text-center font-semibold text-ink tabular-nums" data-testid={`${tid}-count`}>{value}</span>
      <button type="button" onClick={onInc} disabled={incDisabled} data-testid={`${tid}-inc`} aria-label={`Increase ${label}`} className={btnCls}>
        <Plus className="w-4 h-4" />
      </button>
    </div>
  </div>
);

// Adults and children have separate limits, exactly as the room allows.
export const GuestSteppers = ({
  adults, setAdults, childrenCount, setChildrenCount,
  maxAdults = 1, maxChildren = 0, childRuleText = "", childrenAllowed = true, idPrefix = "",
}) => {
  const childCap = childrenAllowed ? maxChildren : 0;
  return (
    <div className="divide-y divide-black/5">
      <Row
        label="Adults" sub={`Ages 18+ · up to ${maxAdults}`} value={adults}
        onDec={() => setAdults(Math.max(1, adults - 1))}
        onInc={() => setAdults(Math.min(maxAdults, adults + 1))}
        decDisabled={adults <= 1} incDisabled={adults >= maxAdults}
        tid={`${idPrefix}adults`}
      />
      {childCap > 0 ? (
        <div>
          <Row
            label="Children (7–17 years)" sub={`Up to ${childCap}`} value={childrenCount}
            onDec={() => setChildrenCount(Math.max(0, childrenCount - 1))}
            onInc={() => setChildrenCount(Math.min(childCap, childrenCount + 1))}
            decDisabled={childrenCount <= 0} incDisabled={childrenCount >= childCap}
            tid={`${idPrefix}children`}
          />
          {childRuleText && (
            <p className="pb-3.5 -mt-1 text-xs text-ink-soft" data-testid={`${idPrefix}child-age-rule`}>{childRuleText}</p>
          )}
        </div>
      ) : (
        <p className="py-3.5 text-xs text-ink-soft" data-testid={`${idPrefix}children-not-allowed`}>
          This room doesn't take children
        </p>
      )}
    </div>
  );
};

export default GuestSteppers;
